import React from 'react';
import { styled, LazyImage } from '@teko/ui';

const Wrapper = styled.div(({ isThumbnail, theme, isVisible, isActive }) => `
    width: ${isThumbnail ? '32px' : 'fit-content'};
    height: ${isThumbnail ? '32px' : 'fit-content'};
    border: 1px ${isActive ? theme.brand.primary : '#e0e0e0'} solid;
    position: relative;
    border-radius: 4px;

    margin: 0 8px 12px 0;
    padding: ${isThumbnail ? '4px' : '8px 16px'};
    color: 'black';
    background-color: ${isVisible || isActive ? '#fff' : '#e0e0e0'};
    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: ${isVisible || isActive ? 'pointer' : 'not-allowed'};
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
`);
const Value = styled.span ``;
const VariantItem = ({ option, index, onSelectVariant }) => {
    return (React.createElement(Wrapper, { isActive: option.selected, isVisible: option.visible, onClick: () => onSelectVariant(option, index), isThumbnail: !!option.thumbnailUrl }, option.thumbnailUrl ? (React.createElement(React.Fragment, null,
        React.createElement(LazyImage, { src: option.thumbnailUrl }))) : (React.createElement(Value, null, option.value))));
};

export { VariantItem };
